var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme, { easing } from 'Theme';
import { Button, Icon } from 'elements';
class Input extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            active: false,
            secure: this.props.type === 'password'
        };
        this.handleActive = active => () => this.setState({ active });
        this.handleKeyPress = (event) => {
            if (this.props.onSubmit && event.nativeEvent.keyCode === 13)
                this.props.onSubmit();
        };
        this.toggleSecure = () => this.setState({ secure: !this.state.secure });
        this.handleChange = (event) => {
            // console.log('Input- handleChange', event.target.value)
        };
    }
    render() {
        const _a = this.props, { type, name, value, label, underline, min, max, maxLength, onSubmit } = _a, props = __rest(_a, ["type", "name", "value", "label", "underline", "min", "max", "maxLength", "onSubmit"]);
        const { active, secure } = this.state;
        // console.log('Input - value: ', value)
        const unfolded = active || String(value).length > 0;
        return (React.createElement(Wrapper, Object.assign({}, props),
            label ? (React.createElement(Label, { active: active, unfolded: unfolded }, label)) : null,
            React.createElement(StyledInput, { type: secure ? 'password' : 'text' || type, name: name, value: value, underline: underline, active: active, onChange: this.handleChange, onFocus: this.handleActive(true), onBlur: this.handleActive(false), min: min, max: max, maxLength: maxLength, onKeyPress: onSubmit ? this.handleKeyPress : undefined, secure: secure }),
            type === 'password' && (React.createElement(StyledButton, { onClick: this.toggleSecure },
                React.createElement(StyledIcon, { name: secure ? 'show' : 'hide' })))));
    }
}
Input.defaultProps = {
    underline: true
};
export default Input;
const Wrapper = cxs('label')({
    display: 'block',
    width: '100%',
    position: 'relative'
});
const Label = cxs('div')(({ active, unfolded }) => ({
    height: Theme.fontSize.regular,
    fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
    color: active ? Theme.color.primary : Theme.color.placeholder,
    textAlign: 'left',
    transform: `translateY(${unfolded ? 0 : '100%'})`,
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
}));
Label.propTypes = {
    active: PropTypes.bool,
    unfolded: PropTypes.bool
};
const StyledInput = cxs('input')(({ underline, active, secure }) => (Object.assign({ width: '100%', height: '100%', transition: `border-color 450ms ${easing.spring} 0ms`, paddingRight: secure !== undefined ? Theme.size.space[3] : 0 }, underline
    ? {
        borderBottom: `${Theme.size.hairline} solid ${active
            ? Theme.color.primary
            : Theme.color.hairline}`
    }
    : undefined)));
StyledInput.propTypes = {
    active: PropTypes.bool,
    underline: PropTypes.bool,
    secure: PropTypes.bool
};
const StyledButton = cxs(Button)({
    position: 'absolute',
    bottom: Theme.common.size.font * (Theme.common.size.lineHeight - 1) / 2 + 'px',
    right: 0
});
const StyledIcon = cxs(Icon)({
    color: Theme.color.placeholder
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/Input.tsx
// module id = 161
// module chunks = 0